import { render } from "./AssessmentDetails.vue?vue&type=template&id=58fd3016&scoped=true"
import script from "./AssessmentDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentDetails.vue?vue&type=script&lang=js"

import "./AssessmentDetails.vue?vue&type=style&index=0&id=58fd3016&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fd3016"]])

export default __exports__